import { Smartphone, Monitor } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { TulsiLogo } from "@/lib/brand";

// Shown once per device to ASM / ZSM: which layout do they want here?
export default function ViewModeChooser() {
  const { user, setViewMode, logout } = useAuth();
  const Option = ({ icon: Icon, title, text, mode, testid }) => (
    <button
      type="button"
      onClick={() => setViewMode(mode)}
      data-testid={testid}
      className="w-full text-left rounded-2xl border border-neutral-200 bg-white p-5 hover:border-[#6D2C91] hover:shadow-md transition flex gap-4 items-start"
    >
      <div className="h-12 w-12 rounded-xl tulsi-gradient text-white flex items-center justify-center shrink-0">
        <Icon className="h-6 w-6" />
      </div>
      <div>
        <div className="text-base font-bold text-neutral-900">{title}</div>
        <div className="text-sm text-neutral-500 mt-0.5">{text}</div>
      </div>
    </button>
  );
  return (
    <div className="min-h-screen w-full flex items-center justify-center px-4 py-10 bg-[#f7f5f9]" data-testid="view-mode-chooser">
      <div className="w-full max-w-md space-y-4">
        <div className="flex justify-center mb-2"><TulsiLogo size={52} /></div>
        <div className="text-center">
          <h1 className="text-xl font-bold text-neutral-900">Hi {(user?.name || "").split(" ")[0]}, how do you want to use the app?</h1>
          <p className="text-sm text-neutral-500 mt-1">You can switch any time from the menu.</p>
        </div>
        <Option mode="field" testid="view-mode-field" icon={Smartphone}
          title="Field app"
          text="Mobile view for the market — attendance, route, beat, visits, orders, TA/DA." />
        <Option mode="browser" testid="view-mode-browser" icon={Monitor}
          title="Browser"
          text="Full office view — dashboard, every screen you have access to, and all reports." />
        <button type="button" onClick={logout} className="w-full text-center text-xs text-neutral-400 underline pt-2">
          Log out
        </button>
      </div>
    </div>
  );
}
